// src/services/api.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://website';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 handler — clear session and redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const authAPI = {
  login: (username, password) =>
    api.post('/api/v1/users/login?appversion=admin', {  username, password  }),
};

// ── Tasks (Admin) ─────────────────────────────────────────────────────────────
export const tasksAPI = {
  list:        (params)     => api.get('/api/admin/tasks', { params }),
  get:         (id)         => api.get(`/api/admin/tasks/${id}`),
  stats:       (params)     => api.get('/api/admin/tasks/stats', { params }),
  export:      (params)     => api.get('/api/admin/tasks/export', { params, responseType: 'blob' }),
  byUser:      (userId, p)  => api.get(`/api/admin/tasks/by-user/${userId}`, { params: p }),
  edit:        (id, data)   => api.patch(`/api/admin/tasks/${id}`, data),
  delete:      (id)         => api.delete(`/api/admin/tasks/${id}`),
  bulkDelete:  (ids)        => api.delete('/api/admin/tasks', { data: { ids } }),
  restore:     (id)         => api.post(`/api/admin/tasks/${id}/restore`),
};

export default api;
